// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"live-preview_wrapper__oWtaE"};